module.exports = __webpack_public_path__ + "img/case-lg-1.59a7f274.jpg";